<template lang='pug'>
  #conlayout(ref='layout')
    img()
</template>

<script>
// import { videoPlayer } from "vue-video-player";
// import "video.js/dist/video-js.css";

import { mapGetters } from 'vuex'



import axios from 'axios'

export default {
  name: "home",
  // components: {
  //   videoPlayer
  // },
  data() {
    return {
      lastScrollPos: 0,
      scrollUpdate: false,
      sec:[],//product.home.sec,
      bodyHeight: 0,
      bodyWidth: 0,
      textSize: 12,
    };
  },
  methods: {

    onScroll(e) {
      console.log(e);
    },
    pageUpdate() {
      console.log(this.lastScrollPos);
      for (let item of this.texts)
        if (
          this.lastScrollPos > this.bodyHeight * item.min &&
          this.lastScrollPos < this.bodyHeight * item.max
        ) {
          item.vis = true;
        } else {
          item.vis = false;
        }
    },

  },
  computed: {
    ...mapGetters({
	            getWSStatus: 'getWSStatus',
    }),
    // player() {
    //   return this.$refs.videoPlayer.player;
    // },
    secHeight(){
      return (window.screen.availHeight * .85 );
      // return  750;
    }

  },
  mounted:function(){
      axios({ url: './data/home.json', method: 'get' }).then(res => {
        this.data = []
        if (res.data.sec) {
          this.sec=res.data.sec;
        }
      })
  }
};
</script>
<style lang="less" scoped>
@import "../color";

#conlayout {
  width: 100%;
  height: 100%;
}
#home {
  width: 100%;
  height: 100%;
  background-color: #252525;
  font-size: 0;
  img {
    width: 100%;
  }

  #info {
    width: calc(100% - 20px);
    height: 200px;
    background-color: #252525;
    padding: 10px;
  }
}
#toolbar {
  height: 60px;
  width: calc(100% - 40px);
  background-color: fadeout(@dark_back_color,10%);
  display: flex;
  position: fixed;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 0 40px 10px 0;
  z-index: 999999;
  a {
    color: #dfdfdf;
    font-size: 10pt;
    margin-left: 20px;
  }
}
@media screen and (min-width: 800px){
  .sec{
    width:100%;
    // height:768px;
    // background-color: #444;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    max-height:950px;

    .desc{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .space{
      width:5%;
    }
    .sectitle{
      font-size: 24pt;
      // color:#fff;
      margin: 20px 0;
    }
    .secDesc{
      font-size: 12pt;
      // color:#fff;

    }
  }
}
@media screen and (max-width: 800px){
  .sec{
    width:100%;
    // height:768px;
    // background-color: #444;
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;

    .desc{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 10px 0;
    }
    .space{
      height:0%;
    }
    .sectitle{
      font-size: 16pt;
      // color:#fff;
      margin: 20px 0;
    }
    .secDesc{
      font-size: 10pt;
      // color:#fff;
    }
  }
}
.floatText {
  position: absolute;
  font-size: 30pt;
  color: #fff;
}
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.fade-left-enter-active,
.fade-right-enter-active {
  transition: all 1s ease;
}
.fade-left-leave-active,
.fade-right-leave-active {
  transition: all 1s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-left-enter, .fade-left-leave-to 
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(-50px);
  opacity: 0;
}
.fade-right-enter, .fade-right-leave-to 
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(50px);
  opacity: 0;
}
</style>

